<template>
    <v-app id="backGND">
      <v-overlay :value="loading" z-index="10" opacity="0.88">
        <div class="loader-card">
          <v-progress-circular indeterminate size="52" width="3" color="white"></v-progress-circular>
          <div class="loader-title">Mi Espacio</div>
          <div class="loader-subtitle">Cargando tu contenido...</div>
        </div>
      </v-overlay>
      <div id="Library">
        <navBar />
        <div id="triangle_down">
          <div id="triangle_up">
            <h1
              class="rotate"
              style="
                margin: auto;
                text-align: left;
                font-family: 'Poiret One', sans-serif;
                color: white;
                padding-left: 1rem;
                font-size: 3rem;
              "
            >
              Mi Espacio
            </h1>
            
          </div>
        </div>
  
        <br />
        <div style="margin-bottom: 2em; font-size: 1.2em">
          <span class="error_message"
            ><p>{{ error_message }}</p></span
          >
          <span class="warning_message"
            ><p>{{ warning_message }}</p></span
          >
        </div>
  
        <div v-if="flag_show_content">   
          <!-- <h1              
              style="
                margin: auto;
                text-align: left;
                font-family: 'Poiret One', sans-serif;
                color: red;
                padding-left: 1rem;
                font-size: 3rem;
                text-align: center;
                cursor: pointer;
              "
            >
              Mis Favoritos ♥
            </h1>  
            <h1              
              style="
                margin: auto;
                text-align: left;
                font-family: 'Poiret One', sans-serif;
                color: green;
                padding-left: 1rem;
                font-size: 3rem;
                text-align: center;
                cursor: pointer;
              "
            >
              Completados ✔
            </h1>  -->
            <v-btn class="btnFiltro" rounded color="red" @click="favVideos()">
              Mis Favoritos ♥
            </v-btn>
            <v-btn class="btnFiltro" rounded color="green" @click="completedVideos()"
            >Completados ✔
            </v-btn>  
            <h1 v-if="flag_fav"              
              style="margin: auto; text-align: left;
                font-family: 'Poiret One', sans-serif;
                color: red;
                padding-left: 1rem;
                font-size: 3rem;
                text-align: center;
                cursor: pointer;
              "
            >
              Mis Favoritos ♥
            </h1>  
            <h1
              v-if="!flag_fav"              
              style="margin: auto;
                text-align: left;
                font-family: 'Poiret One', sans-serif;
                color: green;
                padding-left: 1rem;
                font-size: 3rem;
                text-align: center;
                cursor: pointer;
              "
            >
              Completados ✔
            </h1>   
          
          <!-- card que contiene los cursos -->
          <div class="d-flex align-center justify-center flex-wrap" style="gap: 8px">
            <v-pagination
              v-model="page"
              :length="number_pages"
              :total-visible="7"
            ></v-pagination>
            <div v-if="number_pages > 1" class="d-flex align-center" style="gap: 4px">
              <v-text-field
                v-model="jumpToPage"
                type="number"
                :min="1"
                :max="number_pages"
                dense
                outlined
                hide-details
                placeholder="Ir a pág."
                style="max-width: 110px"
                @keyup.enter="goToPage"
              ></v-text-field>
              <v-btn icon small @click="goToPage">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </div>
          <v-progress-linear
            v-if="pageLoading"
            indeterminate
            color="grey lighten-1"
            height="3"
            style="margin-bottom: 0.5rem"
          ></v-progress-linear>
          <v-card class="desktop" style="background-color: transparent">
            <v-row no-gutters align="stretch" class="ma-2">
              <v-col
                class="desktop"
                cols="12"
                md="5"
                lg="4"
                xl="3"
                sm="6"
                v-for="video in shownCards"
                :key="video.id"
              >
                <!-- Llamar el componente de cursos pasandole las props neceserias para el render -->
  
                <div class="text-center">
                  <vidCar
                    :name="video.name"
                    :img="video.img"
                    :instructor="video.instructor"
                    :id="video.id"
                    :serie="video.serie"
                    :description="video.description"
                    :video_type="video.video_type"
                    :dateFormated="video.date"
                    :paginationTab="page"
                  ></vidCar>
                </div>
              </v-col>
            </v-row>
          </v-card>

          
        </div>
      </div>
    </v-app>
  </template>
  <script>
  import navBar from "@/components/navbar";
  import vidCar from "@/components/library_components/video_card";
  import { mapState, mapGetters } from "vuex";
  import { db } from "@/main";
  import moment from "moment";

  const PER_PAGE = 9;

  export default {
    components: { navBar, vidCar },
    data() {
      return {
        loading: true,
        videos_array: [],
        page: 1,
        jumpToPage: null,
        pageLoading: false,
        flag_fav: null,
        warning_message: "",
        error_message: "",
        flag_show_content: true,
      };
    },
    computed: {
      // Fix A: pure computed, no side effects — number_pages derived from array length
      number_pages() {
        return Math.ceil(this.videos_array.length / PER_PAGE);
      },
      // Fix A: fixed items-per-page, no mutation of data properties
      shownCards() {
        const start = (this.page - 1) * PER_PAGE;
        return this.videos_array.slice(start, start + PER_PAGE);
      },
      ...mapState({
        initialTab: (state) => state.pagination.initialTab,
        haveFilter: (state) => state.pagination.haveFilter,
        filterIndex: (state) => state.pagination.filterIndex,
        userID: (state) => state.authModule.user.uid,
      }),
      ...mapGetters(["setInitialTabGetter"]),
    },
    watch: {
      page() {
        this.pageLoading = true;
        setTimeout(() => { this.pageLoading = false; }, 300);
      },
    },
    methods: {
      goToPage() {
        const p = parseInt(this.jumpToPage);
        if (p >= 1 && p <= this.number_pages) this.page = p;
        this.jumpToPage = null;
      },
      // Maps a Firestore video document to the card object shape
      mapVideoDoc(doc) {
        const d = doc.data();
        return {
          name: d.video_name,
          instructor: d.instructor,
          img: d.thumbnail,
          serie: d.serie,
          id: d.id,
          description: d.description,
          video_type: d.video_type,
          date: d.video_date ? moment(d.video_date).format("dddd, ll") : "--------",
        };
      },
      // Fix D: batch-fetch videos by id field, max 10 per Firestore "in" query
      async fetchVideosByIds(ids) {
        if (!ids.length) return [];
        const chunks = [];
        for (let i = 0; i < ids.length; i += 10) {
          chunks.push(ids.slice(i, i + 10));
        }
        // Fix C: Promise.all so all chunks run in parallel and we await them all
        const snapshots = await Promise.all(
          chunks.map(chunk =>
            db.collection("videos").where("id", "in", chunk).get()
          )
        );
        return snapshots.flatMap(snap => snap.docs.map(d => this.mapVideoDoc(d)));
      },
      async loadAllVideos() {
        const snap = await db
          .collection("videos")
          .where("enabled", "==", true)
          .orderBy("upload_at", "desc")
          .get();
        return snap.docs.map(d => this.mapVideoDoc(d));
      },
      // Checks subscription status; sets error/warning messages on this as a side-effect
      async checkAccess() {
        const doc = await db
          .collection("users")
          .doc(this.$store.state.authModule.user.uid)
          .get();
        const data = doc.data();

        if (data.role === "admin") return { isAdmin: true, hasPackage: false };
        if (!data.packages) return { isAdmin: false, hasPackage: false };

        const end = data.packages[data.packages.length - 1].package_end.toDate();
        const today = new Date();

        if (today > end) {
          this.flag_show_content = false;
          this.error_message = "Tu suscripción esta vencida no puedes acceder al contenido.";
          return { isAdmin: false, hasPackage: false };
        }

        const diff = moment(end).diff(moment(today), "days");
        if (diff < 5) {
          const fmt = n => ("0" + n).substr(-2);
          this.warning_message =
            "Tu suscripción esta proxima a vencer, vence el día: " +
            `${fmt(end.getDate())}-${fmt(end.getMonth() + 1)}-${end.getFullYear()} ` +
            `a las: ${end.getHours()}:${fmt(end.getMinutes())}:${fmt(end.getSeconds())}`;
        }

        return { isAdmin: false, hasPackage: true };
      },
      async completedVideos() {
        this.loading = true;
        this.videos_array = [];
        moment.locale("es-MX");
        try {
          const { isAdmin, hasPackage } = await this.checkAccess();

          if (isAdmin) {
            this.videos_array = await this.loadAllVideos();
          } else if (hasPackage) {
            const snap = await db
              .collection("users")
              .doc(this.userID)
              .collection("videos_completed")
              .get();
            const ids = snap.docs.map(d => d.data().video_id).filter(Boolean);
            this.videos_array = await this.fetchVideosByIds(ids);
            this.flag_fav = false;
          } else if (!this.error_message) {
            this.flag_show_content = false;
            this.error_message = "No cuentas con suscripción activa.";
          }

          if (this.initialTab) this.page = this.initialTab;
        } finally {
          this.loading = false;
        }
      },
      async favVideos() {
        this.loading = true;
        this.videos_array = [];
        moment.locale("es-MX");
        try {
          const { isAdmin, hasPackage } = await this.checkAccess();

          if (isAdmin) {
            this.videos_array = await this.loadAllVideos();
          } else if (hasPackage) {
            const snap = await db
              .collection("users")
              .doc(this.userID)
              .collection("my_favorites")
              .get();
            const ids = snap.docs.map(d => d.data().video_id).filter(Boolean);
            this.videos_array = await this.fetchVideosByIds(ids);
            this.flag_fav = true;
          } else if (!this.error_message) {
            this.flag_show_content = false;
            this.error_message = "No cuentas con suscripción activa.";
          }

          if (this.initialTab) this.page = this.initialTab;
        } finally {
          this.loading = false;
        }
      },
    },
    created: async function () {
      moment.locale("es-MX");
      try {
        const { isAdmin, hasPackage } = await this.checkAccess();

        if (isAdmin) {
          this.videos_array = await this.loadAllVideos();
        } else if (hasPackage) {
          const snap = await db
            .collection("users")
            .doc(this.userID)
            .collection("my_favorites")
            .get();
          // Fix C+D: collect all IDs, then batch-fetch in parallel
          const ids = snap.docs.map(d => d.data().video_id).filter(Boolean);
          this.videos_array = await this.fetchVideosByIds(ids);
          this.flag_fav = true;
        } else if (!this.error_message) {
          this.flag_show_content = false;
          this.error_message = "No cuentas con suscripción activa.";
        }

        // Fix B: page restored only after videos_array is fully set,
        // preventing v-pagination from clamping the restored page while length=0
        if (this.initialTab) this.page = this.initialTab;
      } finally {
        this.loading = false;
      }
    },
    destroyed() {},
  };
  </script>
  <style scoped>
  .loader-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.75rem;
    padding: 2.5rem 3.5rem;
    background: rgba(255, 255, 255, 0.06);
    border-radius: 20px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  }
  .loader-title {
    font-family: 'Poiret One', sans-serif;
    font-size: 1.5rem;
    color: white;
    letter-spacing: 0.1em;
    margin-top: 0.25rem;
  }
  .loader-subtitle {
    font-size: 0.8rem;
    color: rgba(255, 255, 255, 0.55);
    letter-spacing: 0.12em;
    text-transform: uppercase;
  }
  .error_message {
    font-weight: 900;
    font-size: 1.1em;
    color: red;
    text-align-last: center;
  }
  
  .warning_message {
    font-weight: 900;
    font-size: 1.1em;
    color: yellow;
    text-align-last: center;
  }
  
  #triangle_up {
    height: 10rem;
  
    background: linear-gradient(
      to top left,
      rgba(255, 0, 0, 0) 0%,
      rgba(255, 0, 0, 0) 50%,
      rgba(0, 0, 0, 1) 50%,
      rgba(0, 0, 0, 1) 100%
    );
  }
  #triangle_down {
    height: 10rem;
  
    background: linear-gradient(
      to top right,
      rgba(255, 0, 0, 0) 0%,
      rgba(255, 0, 0, 0) 50%,
      rgba(200, 200, 200, 1) 50%,
      rgba(200, 200, 200, 1) 100%
    );
  }
  .rotate {
    transform: rotate(-5deg);
  }
  .field {
    margin-top: -20px;
  }
  .centered_input input {
    text-align: center;
  }
  @media (min-width: 768px) {
    .desktop {
      padding: 1rem !important;
    }
  }
  #backGND {
    background-image: url("../assets/back.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    margin-top: auto;
  }
  
  </style>
  


// WEBPACK FOOTER //
// src/components/my_library.vue